import PropTypes from 'prop-types';

const userPropTypes = {
    name: PropTypes.string,
    username: PropTypes.string,
    userDisplayName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
};

const eventAdditionalFiltersPropTypes = PropTypes.arrayOf(
    PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    }).isRequired,
);

const refPropType = PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
        current: PropTypes.any,
    }),
]);

export {
    userPropTypes,
    eventAdditionalFiltersPropTypes,
    refPropType,
};
